<template>
  <Head title="Admin" />

  <AppLayout>
    <div class="container-fluid">
      <div class="row justify-content-center mx-4">
        <div class="col p-0">
          <sixtran-search
            :filter-options="filterOptions"
            :initial-runs="runs"
            :initial-total="total"
            :initial-filters="initialFilters"
          />
        </div>
      </div>
    </div>
  </AppLayout>
</template>

<script setup>
import { Head } from '@inertiajs/vue3';
import AppLayout from '../../../Layouts/AppLayout.vue';

defineProps({
  filterOptions: {
    type: Object,
    default: () => ({
      clients: [],
      integrations: [],
      census_connections: [],
      segments: [],
    }),
  },
  runs: {
    type: Array,
    default: () => [],
  },
  total: {
    type: Number,
    default: 0,
  },
  initialFilters: {
    type: Object,
    default: () => ({}),
  },
});
</script>
